/**
 * Rutas y textos compartidos del embudo membresía → cuenta → aprobación → acceso.
 * Mantiene coherencia entre portal, registro, pendiente y mi-acceso.
 *
 * Embudo canónico VIP (DualCTA / InvitacionExclusivaMux / Stripe sub):
 *   1. Pago Stripe → webhook asigna level=vip (status pending_approval, approved=false)
 *   2. return_url → COMPLETAR_REGISTRO (Clerk sign-up/in + perfil alias/telegram/edad)
 *   3. PENDING_APPROVAL — paso "In review / En revisión" (usuario ve proceso activo)
 *   4. Admin /admin/memberships → telegram_invite_url + approved=true
 *   5. MI_ACCESO — solo con approved + telegram_invite_url
 *
 * Sin completar Clerk no se entrega la invitación (no hay bypass en /mi-acceso).
 */

export const MEMBERSHIP_ACCESS_PORTAL_PATH = "/portal-acceso";

/** Rutas del embudo público (única fuente para Router y redirects). */
export const MEMBERSHIP_ROUTE = {
  REGISTRO: "/registro",
  /**
   * Form post-pago para completar perfil antes de pasar a `PENDING_APPROVAL`.
   * Canónico: `/portal/completar-perfil`.
   * El alias legacy `/completar-registro` se mantiene en el Router como redirect.
   */
  COMPLETAR_REGISTRO: "/portal/completar-perfil",
  PENDING_APPROVAL: "/pending-approval",
  MI_ACCESO: "/mi-acceso",
  ENTRAR: "/entrar",
} as const;

/** Alias legacy — redirect a la ruta canónica `COMPLETAR_REGISTRO`. */
export const MEMBERSHIP_ROUTE_LEGACY_COMPLETAR_REGISTRO = "/completar-registro";

/**
 * Alias en inglés. Stripe success_url y links del embudo deben usar este path
 * para visitantes en inglés; renderiza el mismo `CompleteRegistration`.
 */
export const MEMBERSHIP_ROUTE_EN_COMPLETE_PROFILE = "/portal/complete-profile";

export type MembershipFunnelPath = (typeof MEMBERSHIP_ROUTE)[keyof typeof MEMBERSHIP_ROUTE];

/** Texto del enlace secundario repetido en las pantallas del embudo. */
export const MEMBERSHIP_PORTAL_LINK_TEXT = "Guía de pasos de acceso";

